






















export default {
    name: "DashboardTable",
    props: {
        label: String,
    },
};
